import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import NavigationBar from "./NavigationBar";

import InnkrevingIleggelser from "./InnkrevingIleggelser";
import InnkrevingMiljogebyr from "./InnkrevingMiljogebyr";

import { getIneIleggelseReports } from "../../actions/ineReportsActions";

import sitePaths from "../../constants/sitePaths";
import { innkreving as titleInnkreving } from "../../constants/titles";

import "./innkrevingPageStyles.css";

const InnkrevingPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  const reportData = useSelector((state) => state.innkreving);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    dispatch(getIneIleggelseReports("ALL_DETAILS"))
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = titleInnkreving(pathname);
  }, [pathname]);

  const miljogebyrPrefix = sitePaths.innkreving.miljogebyr.shortUrl.replace(
    /\/$/,
    "",
  );
  const isMiljogebyrSection = pathname.startsWith(miljogebyrPrefix);

  return (
    <div>
      <NavigationBar />
      {isMiljogebyrSection ? (
        <InnkrevingMiljogebyr reportData={reportData} isLoading={isLoading} />
      ) : (
        <InnkrevingIleggelser reportData={reportData} isLoading={isLoading} />
      )}
    </div>
  );
};

export default InnkrevingPage;
